import type { ReactNode } from 'react'
import { useMatch } from 'react-router'
import {
  SplitViewSidebarListItem,
  SplitViewSidebarListItemArrow,
  SplitViewSidebarListItemTitle,
  SplitViewSidebarListItemSubtitle,
} from '@/components/SplitView/SplitViewSidebarListItem'

export interface NavItemProps {
  to: string
  title: string
  children: ReactNode
}

/**
 * A split view sidebar item that is active while its route matches.
 */
export function NavItem({ to, title, children }: NavItemProps) {
  const active = Boolean(useMatch({ path: to, end: false }))
  return (
    <SplitViewSidebarListItem
      to={to}
      active={active}
      extras={<SplitViewSidebarListItemArrow />}
    >
      <SplitViewSidebarListItemTitle>{title}</SplitViewSidebarListItemTitle>
      <SplitViewSidebarListItemSubtitle>
        {children}
      </SplitViewSidebarListItemSubtitle>
    </SplitViewSidebarListItem>
  )
}
